import { useEffect, useState } from 'react';
import { useAuthStore } from './useAuthStore';
import { autorun } from 'mobx';

// useIsAuthenticatedAfterHydration is used to ensure the initial loading value of isAuthenticated is the same on the server as it is on the client
// on the server isAuthenticated is always false (user is not known during build time)
// on the client we only set the value after hydration is done by putting it in a useEffect
// this avoids hydration errors when conditional rendering is used based on whether the user is logged in
export function useIsAuthenticatedAfterHydration() {
	const authStore = useAuthStore();

	const [isAuthenticated, setIsAuthenticated] = useState(false);

	// using autorun to ensure isAuthenticated is reactive given that it's derived from a mobx store
	// https://mobx.js.org/react-integration.html#useeffect
	useEffect(
		() => autorun(() => setIsAuthenticated(authStore.isAuthenticated)),
		[],
	);

	return isAuthenticated;
}
